<div class="wrapperModal"
  [class.no-max-height]="noMaxHeight"
  [style.z-index]="zindex">
  <div class="wrapperModal__bg" (click)="toggleModal.emit()"></div>
  <div class="wrapperModal__content {{classType}}"
    [class.disabled-scroll]="disabledContentScroller"
    [ngStyle]="{ 'width': widthPx }">
    <div class="wrapperModal__content-header" *ngIf="showHeader">
      <div class="wrapperModal__content-header-text">
        <h2>{{title}}</h2>
        <h3 *ngIf="showSubTitle">{{subTitle}}</h3>
      </div>
      <span (click)="toggleModal.emit()"><i aria-hidden="true" class="icon-close"></i></span>
    </div>
    <div class="wrapperModal__content-body">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>
